import React, { useState, useEffect } from "react";
import { BsArrowLeft, BsPlus } from "react-icons/bs";
import axios from "axios";
import { useNavigate, Link, useParams } from "react-router-dom";
import { Oval } from "react-loader-spinner";

const API_URL = window.BACKEND_URL;

const EditCursoBaner = () => {
  const [baner, setBaner] = useState("");
  const [file, setFile] = useState(null);
  const { id } = useParams();

  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const getBaner = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${API_URL}curso/${id}/banerimg`, {
        headers: {
          Authorization: `${sessionStorage.getItem("token")}`,
          "X-Rol": `${sessionStorage.getItem("role")}`,
        },
      });
      setBaner(response.data);
    } catch (error) {
      console.error("Error fetching baner:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        await getBaner();
      } catch (error) {
        console.error("Error al obtener el baner:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const handleFileChange = (e) => {
    setFile(e.target.files[0]); // Guardar el archivo seleccionado
  };

  const handleInputChange = (e) => {
    setBaner(e.target.value);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      setLoading(true);

      const formData = new FormData();
      formData.append("banerimg", file); // Asegúrate de tener definido 'file' como tu archivo de imagen

      const response = await axios.put(
        `${API_URL}curso/${id}/banerimg`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data", // Especifica el tipo de contenido para archivos
            Authorization: `${sessionStorage.getItem("token")}`,
            "X-Rol": `${sessionStorage.getItem("role")}`,
          },
        }
      );

      if (response.status === 200) {
        console.log("Baner actualizado exitosamente");
        navigate("/Curso");
      } else {
        console.error(
          "Error al actualizar el baner. Estado de respuesta:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error al actualizar el baner:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="row">
      <div className="col-12">
        <div className="card">
          <div className="card-header">
            <h3 className="card-title mb-0">Editar Baner</h3>
          </div>
          <div className="card-body">
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>Baner</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{baner}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="card-body">
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Seleccionar Archivo:</label>
                    <input
                      type="file"
                      name="banerimg"
                      className="form-control"
                      onChange={handleFileChange}
                    />
                  </div>
                </div>
              </div>
              <div className="d-flex justify-content-between mt-2">
                <Link className="btn btn-primary" to="/Curso">
                  <BsArrowLeft style={{ fontSize: "1.6em" }} /> Regresar
                </Link>
                <button type="submit" className="btn btn-primary">
                  {loading ? (
                    <Oval
                      color="#00BFFF"
                      height={40}
                      width={40}
                      loading={loading}
                    />
                  ) : (
                    <>
                      Actualizar Baner <BsPlus style={{ fontSize: "2em" }} />{" "}
                      {/* Cambiado de "Portada" a "Baner" */}
                    </>
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditCursoBaner;
